import React from "react";
import { Typography, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { QuestionnaireItemFreeTextSize } from "../../../../_helpers";

const FreeTextQuestion = ({ q, error }) => {
  const { t } = useTranslation()
  
  const freeTextVariant = {
    [QuestionnaireItemFreeTextSize.Small]: "body2",  
    [QuestionnaireItemFreeTextSize.Medium]: "body1",  
    [QuestionnaireItemFreeTextSize.Large]: "h6",      
  };

  const variant = freeTextVariant[q.freeTextSize] || "body1"; 
  return (
    <Box sx={{ p: 1 }}>
      <Typography variant={variant}>
        {q.text || t('questionnaire.form.actionToolbar.addFreeText')}
      </Typography>
    </Box>
  );
};

export default FreeTextQuestion;
